import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { map, take } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';

@Injectable({
    providedIn: 'root',
})
/**
 * Check if user have token
 */
export class AuthGuard {
    private readonly authService = inject(AuthService);
    private readonly router = inject(Router);

    canActivate() {
        return this.authService.readyUser$.pipe(
            take(1),
            map((user) => (user !== null ? true : this.router.parseUrl('/auth/login')))
        );
    }
}
